export default "__VITE_ASSET__DiMMb6E$__"